import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

import { AsistenteDireccionFormComponent } from '../asistente-direccion-form/asistente-direccion-form.component';
import { Direccion } from '../../../../models/direccion';
import { HttpGenericService } from 'src/app/services/http-generic.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { TipoDeMensajeSwal } from 'src/app/models/enums/tipo-de-mensaje-swal';

@Component({
  selector: 'app-direccion-form',
  templateUrl: './direccion-form.component.html',
  styleUrls: ['./direccion-form.component.css']
})
export class DireccionFormComponent implements OnInit {

  titulo: string;
  nombreBotonCerrar: string;
  onCerrar: Subject<Direccion>;

  paises = [];
  departamentos = [];
  municipios = [];
  
  public modelo = new Direccion();
  bsModalRefAsistenteDireccion: BsModalRef;

  constructor(
    private modalService: BsModalService,
    private httpGeneric: HttpGenericService,
    public bsModalRef: BsModalRef,
    private swal: SweetAlertService) { }

  ngOnInit() {
    this.onCerrar = new Subject();
    this.getPaises();
  }

  guardar() {
    this.modelo.pais = this.paises.filter(p => p.id == this.modelo.idPais).map(p => p.nombre).toString();
    this.modelo.departamento = this.departamentos.filter(d => d.id == this.modelo.idDepartamento).map(d => d.nombre).toString();
    this.modelo.municipio = this.municipios.filter(m => m.id == this.modelo.idMunicipio).map(m => m.nombre).toString();
    this.onCerrar.next(this.modelo);
    this.bsModalRef.hide();
  }

  getDireccion(direccion: Direccion) {
    this.modelo = direccion;
    this.getDepartamentos();
    this.getMunicipios();
  }

  abrirModalAsistenteDireccion() {
    let options = {
      keyboard: true,
      ignoreBackdropClick: true,
      initialState: {
        titulo: 'Asistente para direcciones'
      },
      class: 'modal-lg'
    }

    this.bsModalRefAsistenteDireccion = this.modalService.show(AsistenteDireccionFormComponent, options);
    this.bsModalRefAsistenteDireccion.content.nombreBotonCerrar = 'Cerrar';

    this.bsModalRefAsistenteDireccion.content.onCerrar.subscribe(direccion => {
      this.modelo.direccion = direccion;
    });
  }

  getPaises() {
    this.httpGeneric.get('paises')
    .subscribe(data => {
      this.paises = data;
    }, err => {
      this.swal.mostrar(TipoDeMensajeSwal.Error, 'Ha ocurrido un error, intente mas tarde', '');
    });
  }

  getDepartamentos() {
    this.httpGeneric.get(`paises/${this.modelo.idPais}/departamentos`)
    .subscribe(data => {
      this.departamentos = data;
    }, err => {
      this.swal.mostrar(TipoDeMensajeSwal.Error, 'Ha ocurrido un error, intente mas tarde', '');
    });
  }

  getMunicipios() {
    this.httpGeneric.get(`departamentos/${this.modelo.idDepartamento}/municipios`)
    .subscribe(data => {
      this.municipios = data;
    }, err => {
      this.swal.mostrar(TipoDeMensajeSwal.Error, 'Ha ocurrido un error, intente mas tarde', '');
    });
  }

}
